'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: none;\n\n  & + label::before {\n    background: ', ';\n    border-radius: ', ';\n    border: 1px solid ', ';\n    color: transparent;\n    content: \'\f00c\';\n    cursor: pointer;\n    display: inline-block;\n    font-family: FontAwesome;\n    font-size: ', ';\n    height: ', ';\n    text-align: center;\n    transition: all 200ms ease;\n    width: ', ';\n  }\n\n  & + label {\n    color: ', ';\n\n    &:hover {\n      color: ', ';\n    }\n  }\n\n  &:checked + label::before {\n    color: ', ';\n  }\n\n  &:checked + label {\n    color: ', ';\n  }\n\n  &:hover + label::before {\n    border: 1px solid ', ';\n  }\n'], ['\n  display: none;\n\n  & + label::before {\n    background: ', ';\n    border-radius: ', ';\n    border: 1px solid ', ';\n    color: transparent;\n    content: \'\\f00c\';\n    cursor: pointer;\n    display: inline-block;\n    font-family: FontAwesome;\n    font-size: ', ';\n    height: ', ';\n    text-align: center;\n    transition: all 200ms ease;\n    width: ', ';\n  }\n\n  & + label {\n    color: ', ';\n\n    &:hover {\n      color: ', ';\n    }\n  }\n\n  &:checked + label::before {\n    color: ', ';\n  }\n\n  &:checked + label {\n    color: ', ';\n  }\n\n  &:hover + label::before {\n    border: 1px solid ', ';\n  }\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return (0, _styledComponents.css)(_templateObject, theme.colors.base.background, theme.dimensions.borderRadius, theme.colors.base.chrome400, (0, _decisivUiUtils.px2rem)(16), (0, _decisivUiUtils.px2rem)(18), (0, _decisivUiUtils.px2rem)(18), theme.colors.base.textLight, theme.colors.base.text, theme.colors.base.linkHover, theme.colors.base.text, theme.colors.base.chrome600);
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome400: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var Input = (0, _decisivUiUtils.buildStyledComponent)('Checkbox__Input', _styledComponents2.default.input.attrs({ type: 'checkbox' }), styles, { themePropTypes: themePropTypes });

exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Checkbox/Input.js
// module id = 1558
// module chunks = 2